import { Database } from 'types/supabase'
import { supabaseClient } from 'supabase'

export type Creative = Database['public']['Tables']['creatives']['Row'] & {
  advertiser: {
    id: string
    name: string
  }
}

export const queryCreatives = async (): Promise<Creative[]> => {
  const { data, error } = await supabaseClient
    .from('creatives')
    .select(`
      *,
      advertiser:advertisers!advertiser_id (
        id,
        name
      )
    `)
    .order('created_at', { ascending: false })

  if (error) {
    throw error
  }

  return data as Creative[]
}

export const queryCreativesByAdvertiser = async (advertiserId: string): Promise<Creative[]> => {
  const { data, error } = await supabaseClient
    .from('creatives')
    .select(`
      *,
      advertiser:advertisers!advertiser_id (
        id,
        name
      )
    `)
    .eq('advertiser_id', advertiserId)
    .order('created_at', { ascending: false })

  if (error) {
    throw error
  }

  return data as Creative[]
}

export const queryCreativeByID = async (id: string): Promise<Creative | null> => {
  const { data, error } = await supabaseClient
    .from('creatives')
    .select(`
      *,
      advertiser:advertisers!advertiser_id (
        id,
        name
      )
    `)
    .eq('id', id)
    .single()

  if (error) {
    if (error.code === 'PGRST116') {
      return null // No rows returned
    }
    throw error
  }

  return data as Creative
}